(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileOffice365EmailsUserRecentLoginEvents', ["path", "$q", "userDao", "widgetPolling", "tablePaginationHelper", "columnsHelper", function (path, $q, userDao, widgetPolling, tablePaginationHelper, columnsHelper) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/office365_emails_user/recent-login-events').template('recent-login-events'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                $scope.options = {
                    options: {
                        defaultOrdering: {
                            columnName: 'last_updated',
                            order: 'desc'
                        },
                        autoUpdate: 90000
                    },
                    columns: [
                        {
                            id: 'entity_id',
                            hidden: true,
                            primary: true
                        },
                        {
                            id: 'last_updated',
                            text: 'Date & Time',
                            converter: 'doubleLineDate'
                        },
                        {
                            id: 'client_ip',
                            text: 'IP Address'
                        },
                        {
                            id: 'status',
                            text: 'Status'
                        },
                        {
                            id: 'country',
                            text: 'Country'
                        },
                        {
                            id: 'region',
                            text: 'Region'
                        }
                    ]
                };
                $scope.tableOptions = {
                    asDivs: true,
                    disableTop: true,
                    disableTotalRows: true,
                    dropdownHeader: true,
                    infinite: true,
                    orderDisplayMode: 'highlight-column',
                    pagesAround: 2,
                    pagination: {
                        pageSize: 20,
                        ordering: {}
                    },
                    reloadUuid: true,
                    saveState: true,
                    showWorkingIndicator: false,
                    workingIndicatorDisableGui: false
                };
                $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                    var q = userDao.loginEvents(id, 'office365_emails', $scope.options.columns);
                    if (args.columnsFilters) {
                        q.params(columnsHelper.filtersToParams(args.columnsFilters));
                    }
                    return q.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order);
                }, function (tableModel) {
                    $scope.tableModel = tableModel;
                });
            }
        };
    }]);
}());